import React from 'react';

const Bridge = ({ severity }) => {
  return (
    <div className="bridge" data-sev={severity} />
  );
};

export default Bridge;
